<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-4 pt-md-1 pt-sm-0 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/></svg>
            <h1 class="dashboard__header--title m-0 header">Accounts</h1>
            <!-- <button class="btn btn--white" @click="getTemplate()">Generate</button> -->
          </div>
        </div>

        <!-- Date Range -->
        <div class="col-sm-12 col-md-8 text-right dashboard__header--col-right display-table justify-content-end">
          <s-dropdown class="display-table-cell mr-2 w-content" display="select" :options="listAccountsTypes" v-model="selectedAccountTypeFilter"></s-dropdown>
          <div class="dashboard__header--picker display-table-cell mt-sm-2 mt-md-2 mt-lg-0 display-inline-block white-space-nowrap">
            <date-range-picker @toggle="detectDateRangeState" v-clickaway="closeDateRangePicker" @update="updateDatee" ref="picker" opens="left" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' }" :showWeekNumbers="false" :timePicker="false" :autoApply="false" v-model="showDateRange" placeholder="mm/dd/yyyy">
              <div slot="input" slot-scope="picker">
                  <button class="btn btn--white display-table px-3" ref="btn-picker">
                      <svg class="display-table-cell mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.4062C0 16.2861 0.713867 17 1.59375 17H13.2812C14.1611 17 14.875 16.2861 14.875 15.4062V6.375H0V15.4062ZM2.125 9.03125C2.125 8.73906 2.36406 8.5 2.65625 8.5H12.2188C12.5109 8.5 12.75 8.73906 12.75 9.03125V11.1562C12.75 11.4484 12.5109 11.6875 12.2188 11.6875H2.65625C2.36406 11.6875 2.125 11.4484 2.125 11.1562V9.03125ZM13.2812 2.125H11.6875V0.53125C11.6875 0.239062 11.4484 0 11.1562 0H10.0938C9.80156 0 9.5625 0.239062 9.5625 0.53125V2.125H5.3125V0.53125C5.3125 0.239062 5.07344 0 4.78125 0H3.71875C3.42656 0 3.1875 0.239062 3.1875 0.53125V2.125H1.59375C0.713867 2.125 0 2.83887 0 3.71875V5.3125H14.875V3.71875C14.875 2.83887 14.1611 2.125 13.2812 2.125Z" fill="#52749C"/>
                      </svg>
                      <span class="display-table-cell" v-if="picker.startDate == null && picker.endDate == null">Select date range</span>
                      <span class="display-table-cell mx-2" v-else>{{dateFormat(picker.startDate)}} - {{dateFormat(picker.endDate)}}</span>
                      <svg class="display-table-cell" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.594098 0.908325L8.22252 0.908325C8.75074 0.908325 9.01526 1.54697 8.64176 1.92047L4.82755 5.73468C4.59602 5.96621 4.2206 5.96621 3.98907 5.73468L0.174856 1.92047C-0.198674 1.54697 0.0658798 0.908325 0.594098 0.908325Z" fill="#52749C"/>
                      </svg>
                  </button>
              </div>
            </date-range-picker>
          </div>
        </div>

      </div>

      <!-- Table -->
      <div id="products-table">
        <!-- v-if="(accountsList && accountsList.length && !loading) || showSearch" -->
        <div class="products-table__search" >
          <s-input placeholder="Search for an account by a user’s name, email or domain" v-model="searchAccount"></s-input>
        </div>
        <s-card class="products-table__card border-top-0 p-0">
          <s-card-body class="product-table__table p-0">
              <div class="product-table__table-container" @scroll="getScrollPos">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && accountsList && accountsList.length"></div>
                  <!-- accountsList && accountsList.length &&  -->
                  <!-- style="width: 1731px;" -->
                  <table v-if="(!loading) || showSearch" class="product-table__table--table"  id="myTable">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- Account ID -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>ID</span>
                          </td>
                          <!-- Name -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Name</span>
                          </td>
                          <!-- Stores -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Stores</span>
                          </td>
                          <!-- JOINED -->
                          <td  @click="clickSortField('created_at')"  class="text-truncate product-table__table--header-joined cursor-pointer">
                              <span>JOINED</span>
                              <svg :style="sortField == 'created_at' && sortType == 'ASC' ? 'transform: rotate(180deg);' : ''" class="ml-2"  width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.741224 -3.23999e-08L10.2588 -4.48426e-07C10.9178 -4.77233e-07 11.2479 0.894104 10.7819 1.417L6.02307 6.75689C5.73421 7.08103 5.26581 7.08103 4.97694 6.75689L0.218158 1.417C-0.247875 0.894104 0.0821946 -3.59285e-09 0.741224 -3.23999e-08Z" fill=" #2ecc71"/></svg>
                          </td>
                          <!-- Last Active     transform: rotate(180deg); -->
                          <td @click="clickSortField('last_active')" class="text-truncate product-table__table--header-joined cursor-pointer">
                              <span>Last Active</span>
                              <svg :style="sortField == 'last_active' && sortType == 'ASC' ? 'transform: rotate(180deg);' : ''" class="ml-2"  width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.741224 -3.23999e-08L10.2588 -4.48426e-07C10.9178 -4.77233e-07 11.2479 0.894104 10.7819 1.417L6.02307 6.75689C5.73421 7.08103 5.26581 7.08103 4.97694 6.75689L0.218158 1.417C-0.247875 0.894104 0.0821946 -3.59285e-09 0.741224 -3.23999e-08Z" fill=" #2ecc71"/></svg>
                          </td>
                          <!-- TRIAL END ON -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>TRIAL END ON</span>
                          </td>
                          <!-- MAUTIC LINK -->
                          <!-- <td class="text-truncate product-table__table--header-joined">
                              <span>MAUTIC LINK</span>
                          </td> -->
                          <!-- Details -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Details</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loading && showSearch">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loading && (accountsList == null || accountsList.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="accountsList && accountsList.length > 0">
                            <tr  v-show="!loading" v-for="(account, accountIndex) in accountsList" :key="accountIndex" class="product-table__table--row w-100">
                                <!-- Account ID -->
                                <td  class="display-table-cell product-table__table--body-joined">
                                  <p class="text-truncate">{{account.id}}</p>
                                </td>
                                <!-- Name -->
                                <td :tooltip-position="accountIndex==0?'right':'top'" :tooltip="account.name" class="display-table-cell product-table__table--body-joined">
                                  <p  class="text-truncate"><span v-html="handleAccountTypeIcon(account)"></span>{{account.name}}</p>
                                </td>
                                <!-- Stores -->
                                <td class="display-table-cell product-table__table--body-domain">
                                  <div class="display-table w-100">
                                    <button :class="showStores[accountIndex]?'active':''" @click.stop="showAccountStores(accountIndex)" class="btn btn--white display-table-cell btn--ga px-3">
                                        <svg class="display-table-cell mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="11" height="4" rx="2" fill="#6CD16A"/>
                                            <rect y="6" width="16" height="4" rx="2" fill="#6CD16A"/>
                                            <rect y="12" width="12" height="4" rx="2" fill="#6CD16A"/>
                                        </svg>
                                        <span class="display-table-cell white-space-nowrap">{{account.stores.length}} Store{{account.stores.length > 1 ? 's' : ''}}</span>
                                        <div style="background: #3fc886; border-radius: 3px; font-weight: 500; font-size: 16px; color: #fff; padding: 5px 18px; margin-right: -12px;" class="ml-4">Details</div>
                                    </button>
                                    
                                    <div v-for="(store,indexStore) in account.stores" :key="indexStore" class="display-table-cell ml-1">
                                      <!-- Logo Wix -->
                                      <img v-if="store.type=='wix'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/wix.svg')" />

                                      <!-- Logo Shopify -->
                                      <img v-else-if="store.type=='shopify'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/shopify.svg')" />

                                      <img v-else-if="store.type=='webflow'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/webflow.svg')" />

                                      <!-- Logo Woocommerce -->
                                      <img v-else-if="store.type=='woocommerce'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/woocommerce.svg')" />

                                      <!-- Logo Bigcommerce -->
                                      <img v-else-if="store.type=='bigcommerce'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/bigcommerce.svg')" />

                                      <!-- Logo Squarespace -->
                                      <img v-else-if="store.type=='squarespace'" width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/squarespace.svg')" />

                                      <!-- Logo Squarespace -->
                                      <img v-else width="22" height="22" class="display-table-cell icone-plateform" :src="require('@/assets/images/clickfunnels.svg')" />
                                    </div>
                                  </div>
                                </td>
                                <!-- JOINED -->
                                <td class="display-table-cell product-table__table--body-joined">
                                    <p class="text-truncate">{{account.created_at?fromNow(account.created_at):'-'}}</p>

                                </td>
                                <!-- Last Active -->
                                <td class="display-table-cell product-table__table--body-joined">
                                    <p class="text-truncate">{{account.last_active?fromNow(account.last_active):'-'}}</p>
                                </td>
                                <!-- TRIAL END ON -->
                                <td class="display-table-cell product-table__table--body-trail-started">
                                    <p class="text-truncate" :class="trialIsEnded(account.trial_end_at) ? 'text-danger':'text-success'">{{account.trial_end_at?fromNow(account.trial_end_at):'-'}}</p>
                                </td>
                                <!-- MAUTIC LINK -->
                                <!-- <td class="product-table__table--body-joined">
                                    <a :href="'https://m.scalify.com/s/contacts/view/'+account.mautic_id" target="_blank" class="text-truncate text-primary">Link</a>
                                </td> -->
                                <!-- Details -->
                                <td class="display-table-cell product-table__table--body-trail-started">
                                   <!-- @click="accountDetails(account.id)" -->
                                  <a :href="`/account/${account.id}`" class="btn btn--primary display-table-cell">
                                    <span class="display-table-cell">Details</span>
                                  </a>
                                </td>
                                <br>
                                <!-- Table Stores -->
                                <div v-if="account && account.stores && account.stores.length > 0 && showStores[accountIndex]" class="border my-2 mx-4" style="border-radius: 5px;width: 760px !important;">
                                  <table  class="product-table__table--table" id="myTable" style="width: 750px !important;">
                                    <thead class="product-table__table--header border-0 p-0 mb-4">
                                        <!-- Account ID -->
                                        <td class="text-truncate product-table__table--header-id">
                                            <span>ID</span>
                                        </td>
                                        <!-- DOMAIN -->
                                        <td class="text-truncate product-table__table--header-domain">
                                            <span>Domain</span>
                                        </td>
                                        <!-- JOINED -->
                                        <td class="text-truncate product-table__table--header-joined cursor-pointer">
                                            <span>JOINED</span>
                                        </td>
                                        <!-- Type -->
                                        <td class="text-truncate product-table__table--header-joined cursor-pointer">
                                            <span>Type</span>
                                        </td>
                                    </thead>
                                    <tbody class="product-table__table--body">
                                        <tr v-for="(store, storeIndex) in account.stores" :key="storeIndex" @click="storeDetails(account.id)" class="product-table__table--row">
                                            <!-- Account ID -->
                                            <td  class="product-table__table--body-id">
                                              <p class="text-truncate">{{store.id}}</p>
                                            </td>
                                            <!-- Domain -->
                                            <td :tooltip-position="storeIndex==0?'right':'top'" :tooltip="store.domain" class="product-table__table--body-domain">
                                              <p  class="text-truncate">{{store.domain}}</p>
                                            </td>
                                            <!-- JOINED -->
                                            <td class="product-table__table--body-joined">
                                                <p class="text-truncate">{{store.created_at?fromNow(store.created_at):''}}</p>
                                            </td>
                                            <!-- Type -->
                                            <td class="product-table__table--body-joined">
                                                <p class="text-truncate">{{store.type}}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                </div>
                            </tr>
                          </div>

                      </tbody>
                  </table>
                  <table v-else-if="loading" class="product-table__table--table" style="width: 100%;" id="myTable">
                    <tbody class="product-table__table--body">
                      <tr class="w-100 display-table-cell">
                        <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                      </tr>
                    </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((accountsList && accountsList.length)||showSearch)"></div>
              </div>
          </s-card-body>
          <s-card-body v-if="accountsList && accountsList.length && !showSearch && loadMoreAccounts && !loading" class="p-0 product-table__load-more text-center">
              <button v-if="!loadingLoadMore" class="btn btn--white" @click="loadMoreAccountsDetails()">Load More</button>
              <s-loader :type="'scalify'" v-else></s-loader>
          </s-card-body>
        </s-card>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  name: 'dashboard',

  components:{
    // MiniChart,
    DateRangePicker
  },

  props: {},

  computed:{
  },

  data(){
    return{
      showDateRange: {},
      valueUpdateDate: null,
      showRangePicker:false,
      accountsList: [],
      searchAccount: "",
      showSearch: false,
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left",
      loadMoreAccounts: true,
      loadingLoadMore: false,
      showStores:[],
      currentPage: 1,
      isLoadMoreSearch: false,
      sortType: "DESC",
      sortField: null,
      
      listAccountsTypes:[
        {name:"All",value:null},
        {name:"Paid",value:"paid"},
        {name:"On Trial",value:"on_trial"},
        {name:"LTD's",value:"ltd"},
        {name:"Cancelled",value:"cancelled"}
      ],
      selectedAccountTypeFilter:{name:"All",value:null}
    }
  },

  methods:{
    async clickSortField(field){
      this.sortType = this.sortType == "ASC" ? "DESC" : "ASC";
      this.sortField = field
      this.loading = true;
      this.currentPage = 1;
      let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
      let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
      const accounts = await this.accountsTable(start,end,this.currentPage,this.sortField,this.sortType,this.selectedAccountTypeFilter);
      if (accounts && accounts.data) {
        this.accountsList = accounts.data;
        if (this.accountsList.length >= 25) {
          this.loadMoreAccounts = true;
        }else{
          this.loadMoreAccounts = false;
        }
        this.currentPage = this.currentPage + 1;
        if (this.accountsList.length > 0) {
          this.showStores = [];
          this.accountsList.map(()=>{
            this.showStores.push(false);
          })
        }
      }
      this.isLoadMoreSearch = false;
      this.loading = false;
    },
    trialIsEnded(date){
      let today = new Date()
      let end = new Date(date)
      let diff_days = moment(end).diff(moment(today), 'minutes')
      if(diff_days > 0){
        return false
      }
      return true
    },
    // accountDetails(accountID){
    //   this.$router.push(`/account/${accountID}`);
    // },
    showAccountStores(accountIndex){
      console.log('accountIndex: ', accountIndex);
      this.showStores[accountIndex] = !this.showStores[accountIndex]
      this.$forceUpdate();
    },
    closeDateRangePicker(){
      this.$nextTick(()=>{
        if(this.showRangePicker){
          this.$refs["btn-picker"].click()
        }
      })
    },
    detectDateRangeState(show){
      this.showRangePicker = show
    },
    async updateDatee(value){
      this.valueUpdateDate = value;
      this.loading = true;
      this.currentPage = 1;
      let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
      let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
      const accounts = await this.accountsTable(start,end,null,null,null,this.selectedAccountTypeFilter);
      if (accounts && accounts.data) {
        this.accountsList = accounts.data;
        this.currentPage++;
        if (accounts.data.length >= 25) {
          this.loadMoreAccounts = true;
        }else{
          this.loadMoreAccounts = false;
        }
      }
      this.isLoadMoreSearch = false;
      this.loading = false;
    },
    dateFormat(date){
      const m = moment(date);
      const ord = m.format("ll");
      return ord;
    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    },
    async loadMoreAccountsDetails(){
      try {

        this.loadingLoadMore = true;
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        let  detailsAccounts;

        if (this.isLoadMoreSearch) {
          detailsAccounts = await this.accountSearch(this.searchAccount,this.currentPage)
        }else{
          if (this.sortField) {
            detailsAccounts = await this.accountsTable(start,end,this.currentPage,this.sortField,this.sortType,this.selectedAccountTypeFilter);
          }else{
            detailsAccounts = await this.accountsTable(start,end,this.currentPage,null,null,this.selectedAccountTypeFilter);
          }
        }
        console.log('detailsAccounts: ', detailsAccounts);
        if (detailsAccounts && detailsAccounts.data) {
          this.accountsList = this.accountsList.concat(detailsAccounts.data);
          if (detailsAccounts.data.length > 0) {
            detailsAccounts.data.map(()=>{
              this.showStores.push(false);
            })
          }
          this.currentPage++;
          // this.currentPage = detailsAccounts.currentPage + 1;
          if (detailsAccounts && detailsAccounts.data && detailsAccounts.data.length >= 25) {
            this.loadMoreAccounts = true;
          }else{
            this.loadMoreAccounts = false;
          }
        }else{
          this.loadMoreAccounts = false;
        }
        this.loadingLoadMore = false;
      } catch (error) {
        this.loadingLoadMore = false;
      }
    },
    handleAccountTypeIcon(account){
      let finalIcon = ""
      if(account && account.subscriptions && account.subscriptions[0] && account.subscriptions[account.subscriptions.length - 1].price > 0 && account.subscriptions[account.subscriptions.length - 1].status == 'active' && !account.subscriptions[account.subscriptions.length - 1].test){
        finalIcon = '<span style="font-size:19px;">🤑</span> '
      }
      else if(account && account.subscriptions && account.subscriptions[0] && account.subscriptions[account.subscriptions.length - 1].price > 0 && account.subscriptions[account.subscriptions.length - 1].status == 'active' && account.subscriptions[account.subscriptions.length - 1].test){
        finalIcon = '<span style="font-size:19px;">🧪</span> '
      }
      else if(account && account.subscriptions && account.subscriptions[0] && account.subscriptions[account.subscriptions.length - 1].price > 0 && account.subscriptions[account.subscriptions.length - 1].status !== 'active' && !account.subscriptions[account.subscriptions.length - 1].test){
        finalIcon = '<span style="font-size:19px;">🚫</span> '
      }

      if(!this.trialIsEnded(account.trial_end_at) && account && account.subscriptions && account.subscriptions[0] && account.account_type !== "sub_account"){
        finalIcon = finalIcon + '<span style="font-size:10px;">⏳</span>  '
      }
      else if(account.account_type == "sub_account"){
        finalIcon = finalIcon + '<span style="font-size:19px;">🇮🇳</span>  '
      }
      
      return finalIcon;
    }

  },

  async created(){
    this.showDateRange = {};
    this.showDateRange['endDate'] = new Date();
    var makeDate = new Date();
    this.showDateRange['startDate'] = new Date(new Date().setMonth(makeDate.getMonth()-1));
  },

  watch:{

    searchAccount:{

      deep: true,
      async handler(){
        if (this.searchAccount == "") {
          this.loading = true;
          this.showSearch = true
          let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
          let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
          const accounts = await this.accountsTable(start,end,null,null,null,this.selectedAccountTypeFilter);
          if (accounts && accounts.data) {
            this.accountsList = accounts.data;
            if (this.accountsList.length >= 25) {
              this.loadMoreAccounts = true;
            }else{
              this.loadMoreAccounts = false;
            }
            this.currentPage = 1;
            if (this.accountsList.length > 0) {
              this.showStores = [];
              this.accountsList.map(()=>{
                this.showStores.push(false);
              })
            }
          }
          this.isLoadMoreSearch = false;
          this.loading = false;
          this.showSearch = false

        }else if(this.searchAccount.length >= 3){
          this.loading = true;
          this.showSearch = true
          var t = 1000;

          clearTimeout(window.popTimeout);

          window.popTimeout = setTimeout(async () => {
            const resultSearch = await this.accountSearch(this.searchAccount);
            console.log('resultSearch: ', resultSearch);
            if (resultSearch && resultSearch.data) {

              this.accountsList = resultSearch.data;
              if (this.accountsList.length >= 25) {
                this.loadMoreAccounts = true;
              }else{
                this.loadMoreAccounts = false;
              }
              this.currentPage = 1;
              if (this.accountsList && this.accountsList.length > 0) {
                this.showStores = [];
                this.accountsList.map(()=>{
                  this.showStores.push(false);
                })
              }
            }
            this.isLoadMoreSearch = true;
            this.showSearch = false
            this.loading = false;
          }, t);
        }
      }

    },
    selectedAccountTypeFilter:{
      deep:true,
      async handler(){
        this.loading = true;
        this.showSearch = true
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        const accounts = await this.accountsTable(start,end,null,null,null,this.selectedAccountTypeFilter);
        if (accounts && accounts.data) {
          this.accountsList = accounts.data;
          if (this.accountsList.length >= 25) {
            this.loadMoreAccounts = true;
          }else{
            this.loadMoreAccounts = false;
          }
          this.currentPage = 1;
          if (this.accountsList.length > 0) {
            this.showStores = [];
            this.accountsList.map(()=>{
              this.showStores.push(false);
            })
          }
        }
        this.isLoadMoreSearch = false;
        this.loading = false;
        this.showSearch = false
      }
    }

  },

  async mounted(){

    this.loading = true
    let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
    let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
    const accounts = await this.accountsTable(start,end,this.currentPage,null,null,this.selectedAccountTypeFilter);
    console.log('accounts: ', accounts);
    if (accounts && accounts.data) {
      this.accountsList = accounts.data;
      if (this.accountsList.length > 0) {
        this.accountsList.map(()=>{
          this.showStores.push(false);
        })
      }
      this.currentPage++;
      if (accounts && accounts.data && accounts.data.length >= 25) {
        this.loadMoreAccounts = true;
      }else{
        this.loadMoreAccounts = false;
      }
      this.loading = false
    }

  }


}
</script>

<style scoped>

</style>
